
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coupons/[couponId]",
      function () {
        return require("private-next-pages/coupons/[couponId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coupons/[couponId]"])
      });
    }
  